import * as tslib_1 from "tslib";
import dashboardApi from '@/services/dashboard';
import { timeFormat } from '@/shared/utils';
import { useAntdTable } from 'ahooks';
import { Table } from 'antd';
import moment from 'moment';
import React from 'react';
import styled from 'styled-components';
const Root = styled.div ``;
var TaskType;
(function (TaskType) {
    TaskType["start"] = "\u521D\u59CB\u72B6\u6001";
    TaskType["dev"] = "\u5F00\u53D1\u9636\u6BB5";
    TaskType["smokeTest"] = "\u5192\u70DF\u6D4B\u8BD5";
    TaskType["test"] = "\u6D4B\u8BD5\u9636\u6BB5";
    TaskType["prepub"] = "\u9884\u53D1\u9636\u6BB5";
    TaskType["pro"] = "\u7EBF\u4E0A\u9636\u6BB5";
    TaskType["publishFinished"] = "\u53D1\u5E03\u5B8C\u6210";
    TaskType["approvalRejectFinished"] = "\u5BA1\u6279\u62D2\u7EDD";
    TaskType["cancel"] = "\u53D1\u5E03\u53D6\u6D88";
    TaskType["timeout"] = "\u53D1\u5E03\u8D85\u65F6";
})(TaskType || (TaskType = {}));
const detailUrlPrefixTest = 'http://f2e.dasouche-inc.net/projects/data-fe/cybertron-cooperation-web/index.html#/dashboard/';
const detailUrlPrefixPro = 'https://f2e-assets.souche-inc.com/projects/data-fe/cybertron-cooperation-web/index.html#/dashboard/';
const MyDeploy = ({ className, style }) => {
    const columns = [
        // {
        //   title: '任务ID',
        //   dataIndex: 'id',
        // },
        {
            title: '任务名称',
            dataIndex: 'publishName',
            width: '27%',
        },
        {
            title: '当前阶段',
            dataIndex: 'state',
            render: (text) => {
                return text ? TaskType[text] : '-';
            },
            width: '15%',
        },
        {
            title: '计划发布时间',
            dataIndex: 'publishTime',
            render: (text) => {
                return moment(text).format(timeFormat.dayFormat);
            },
            width: '18%',
        },
        {
            title: '创建人',
            dataIndex: 'createUserName',
            width: '10%',
        },
        {
            title: '创建时间',
            dataIndex: 'createTime',
            render: (text) => {
                return moment(text).format(timeFormat.dayFormat);
            },
            width: '18%',
        },
        {
            title: '操作',
            dataIndex: 'id',
            width: '12%',
            render: (text) => {
                return (<a onClick={() => {
                    if (process.env.MUJI_APP_ENV === 'prod') {
                        window.open(`${detailUrlPrefixPro}${text}`);
                    }
                    else {
                        window.open(`${detailUrlPrefixTest}${text}`);
                    }
                }}>
            查看详情
          </a>);
            },
        },
    ];
    const getDeployPage = (params) => tslib_1.__awaiter(this, void 0, void 0, function* () {
        return yield dashboardApi.fetchMyDeploy(true, params.current, params.pageSize, moment().subtract(14, 'days').format(timeFormat.dayFormat)).promise;
    });
    const { tableProps } = useAntdTable(getDeployPage, {
        defaultPageSize: 10,
        formatResult: (res) => {
            return {
                total: res.totalNumber,
                list: res.items,
            };
        },
    });
    return (<Root className={className} style={style}>
      <Table scroll={{ y: 300 }} columns={columns} {...tableProps} rowKey={'id'} locale={{
        emptyText: '您最近没有发布任务',
    }}/>
    </Root>);
};
export default MyDeploy;
